export enum HttpError {
  HTTP_BAD_REQUEST = 400,
  HTTP_UNAUTHORIZED = 401,
  HTTP_FORBIDDEN = 403,
  HTTP_REQUEST_TIMEOUT = 408,
  HTTP_INTERNAL_SERVER_ERROR = 500,
  HTTP_BAD_GATEWAY = 502,
  HTTP_GATEWAY_TIMEOUT = 504
}
